export enum OrderState {
  NEW = 'NEW',
  DELIVERED = 'DELIVERED'
}
